var _linearGradient, _linearGradient2, _linearGradient3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFirebaseLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 230 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.56,17.49a1.21,1.21,0,0,0-1.38-1,1.1,1.1,0,0,0-.65.33l-6.24,6.23-4.88-9.32a1.2,1.2,0,0,0-1.62-.51,1.39,1.39,0,0,0-.51.51l-2.66,5.1L8.91,6.31a1.19,1.19,0,0,0-1.62-.47,1.23,1.23,0,0,0-.63.86L.16,48.22,17.51,58A3.63,3.63,0,0,0,21,58l17.5-9.74Z",
    style: {
      fill: "none"
    }
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 7.63,
    y1: -231.98,
    x2: 5.24,
    y2: -233.23,
    gradientTransform: "translate(0 265.99)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a52714"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#a52714",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#a52714",
    stopOpacity: 0
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 17.81,
    y1: -235.47,
    x2: 16.74,
    y2: -236.54,
    gradientTransform: "translate(0 265.99)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a52714",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#a52714",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a52714",
    stopOpacity: 0
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: -620.54,
    y1: -1271.77,
    x2: -605.55,
    y2: -1286.77,
    gradientTransform: "matrix(2.67, 0, 0, -2.67, 1655.98, -3380.66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))), /*#__PURE__*/React.createElement("rect", {
    x: -8.52,
    y: 4.59,
    width: 55.47,
    height: 55.47,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.16,48.22,6.66,6.7A1.18,1.18,0,0,1,8,5.72a1.26,1.26,0,0,1,.87.62l6.71,12.53,2.66-5.1a1.2,1.2,0,0,1,1.62-.51,1.39,1.39,0,0,1,.51.51l18.1,34.45Z",
    style: {
      fill: "#ffa000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.33,6-9.43,3.29V60.81L.16,48.22Z",
    style: {
      opacity: 0.119999997317791,
      isolation: "isolate",
      fill: "url(#b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6,32.05l-7-13.21L.16,48.22Z",
    style: {
      fill: "#f57c00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9.43,3.29H48.09V60.81H-9.43Z",
    style: {
      opacity: 0.200000002980232,
      isolation: "isolate",
      fill: "url(#c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.51,48.22l-5-30.76a1.21,1.21,0,0,0-1.38-1,1.13,1.13,0,0,0-.65.33L.16,48.22,17.51,58A3.63,3.63,0,0,0,21,58Z",
    style: {
      fill: "#ffca28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.56,17.49a1.21,1.21,0,0,0-1.38-1,1.1,1.1,0,0,0-.65.33l-6.24,6.23-4.88-9.32a1.2,1.2,0,0,0-1.62-.51,1.39,1.39,0,0,0-.51.51l-2.66,5.1L8.91,6.31a1.19,1.19,0,0,0-1.62-.47,1.23,1.23,0,0,0-.63.86L.16,48.22h0l0,0,.18.09,25-25,6.24-6.23a1.18,1.18,0,0,1,1.7,0,1.07,1.07,0,0,1,.33.66l4.92,30.46.06,0ZM.22,48.16,6.66,7A1.17,1.17,0,0,1,8,6a1.23,1.23,0,0,1,.87.62l6.71,12.53,2.66-5.1a1.19,1.19,0,0,1,1.62-.51,1.39,1.39,0,0,1,.51.51l4.79,9.11Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.200000002980232
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,57.66a3.63,3.63,0,0,1-3.5,0L.19,48l0,.27L17.51,58A3.63,3.63,0,0,0,21,58l17.5-9.74,0-.27Z",
    style: {
      fill: "#a52714",
      opacity: 0.200000002980232,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.56,17.49a1.21,1.21,0,0,0-1.38-1,1.1,1.1,0,0,0-.65.33l-6.24,6.23-4.88-9.32a1.2,1.2,0,0,0-1.62-.51,1.39,1.39,0,0,0-.51.51l-2.66,5.1L8.91,6.31a1.19,1.19,0,0,0-1.62-.47,1.23,1.23,0,0,0-.63.86L.16,48.22,17.51,58A3.63,3.63,0,0,0,21,58l17.5-9.74Z",
    style: {
      fill: "url(#d)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75.42,48H71.28V15.91H90.05v4H75.42V30.43H88.64v3.86H75.45V48Zm21.75-27.5A3,3,0,1,1,98,18.47,2.91,2.91,0,0,1,97.17,20.54Zm0,27.5H93V26h4.14Zm8.63,0h-4.14V26h4v3.58h.18a5.47,5.47,0,0,1,2.6-2.94,7.3,7.3,0,0,1,3.78-1.16,8,8,0,0,1,3.09.52l-1.58,3.86a6.14,6.14,0,0,0-2.21-.31,5.31,5.31,0,0,0-4,1.79A6.33,6.33,0,0,0,105.8,36Zm19.44.74a10.61,10.61,0,0,1-8.11-3.33A11.82,11.82,0,0,1,114,37.06a12.3,12.3,0,0,1,3-8.28,9.83,9.83,0,0,1,7.75-3.47,10.07,10.07,0,0,1,7.82,3.19,12.09,12.09,0,0,1,3,8.53l0,.77H118.15a7.56,7.56,0,0,0,2.21,5.26A6.68,6.68,0,0,0,125.13,45c3,0,5-1.26,6-3.79l3.68,1.54A9.65,9.65,0,0,1,131.31,47,10.33,10.33,0,0,1,125.24,48.78Zm5.93-14.39a5.92,5.92,0,0,0-1.72-3.57,6.2,6.2,0,0,0-4.74-1.72,5.9,5.9,0,0,0-4,1.44,7.23,7.23,0,0,0-2.32,3.85Zm18.91,14.39a9.15,9.15,0,0,1-4.53-1.09,7.42,7.42,0,0,1-3-2.7h-.18v3h-4V15.91h4.14V26l-.18,3.06h.18a7.64,7.64,0,0,1,3-2.7,9.48,9.48,0,0,1,4.53-1.09,9.67,9.67,0,0,1,7.36,3.37A11.8,11.8,0,0,1,160.53,37a11.84,11.84,0,0,1-3.09,8.35A9.6,9.6,0,0,1,150.08,48.78ZM149.37,45a6.61,6.61,0,0,0,4.95-2.18,8,8,0,0,0,2.07-5.75,8,8,0,0,0-2.07-5.75,6.61,6.61,0,0,0-4.95-2.18,6.49,6.49,0,0,0-4.94,2.14,8.18,8.18,0,0,0-2,5.79,8,8,0,0,0,2,5.79A6.53,6.53,0,0,0,149.37,45Zm21.44,3.79a8.58,8.58,0,0,1-5.86-2,6.62,6.62,0,0,1-2.35-5.33,6.64,6.64,0,0,1,2.77-5.65,11.24,11.24,0,0,1,6.88-2,12,12,0,0,1,6,1.33v-.63a5,5,0,0,0-1.65-3.89,5.88,5.88,0,0,0-4.07-1.48,6.46,6.46,0,0,0-3.26.84,4.29,4.29,0,0,0-2,2.35l-3.79-1.61a8.54,8.54,0,0,1,3-3.65,9.68,9.68,0,0,1,5.93-1.68,10.16,10.16,0,0,1,7,2.45,8.8,8.8,0,0,1,2.78,7V48h-4V45H178A8.1,8.1,0,0,1,170.81,48.78Zm.67-3.79a6.66,6.66,0,0,0,4.63-1.89,5.92,5.92,0,0,0,2.1-4.53A8.17,8.17,0,0,0,173,37.13a6.77,6.77,0,0,0-4.53,1.3,4,4,0,0,0-1.54,3,2.91,2.91,0,0,0,1.4,2.56A5.63,5.63,0,0,0,171.48,45Zm22.17,3.79A9.83,9.83,0,0,1,187.58,47a10.46,10.46,0,0,1-3.51-4.49L187.75,41a6.06,6.06,0,0,0,6,4.13,5.44,5.44,0,0,0,3.16-.84A2.65,2.65,0,0,0,198.1,42c0-1.44-1-2.42-3-2.91L190.63,38a10.79,10.79,0,0,1-4-2,4.92,4.92,0,0,1-1.89-4.07,5.6,5.6,0,0,1,2.59-4.73,11,11,0,0,1,11.34-.49,7.18,7.18,0,0,1,3.26,3.79l-3.58,1.47c-.81-1.93-2.49-2.91-5-2.91a5.64,5.64,0,0,0-3.08.77A2.32,2.32,0,0,0,189,31.87c0,1.26,1,2.1,2.91,2.56l4.35,1a8.55,8.55,0,0,1,4.6,2.45,6,6,0,0,1,1.47,4,6.15,6.15,0,0,1-2.42,4.94A9.39,9.39,0,0,1,193.65,48.78Zm21.58,0a10.61,10.61,0,0,1-8.11-3.33A11.82,11.82,0,0,1,204,37.06a12.3,12.3,0,0,1,3-8.28,9.83,9.83,0,0,1,7.75-3.47,10.07,10.07,0,0,1,7.82,3.19A12.09,12.09,0,0,1,225.54,37l0,.77H208.14a7.56,7.56,0,0,0,2.21,5.26A6.68,6.68,0,0,0,215.12,45c2.95,0,5-1.26,6-3.79l3.69,1.54A9.61,9.61,0,0,1,221.29,47,10.28,10.28,0,0,1,215.23,48.78Zm5.92-14.39a5.85,5.85,0,0,0-1.71-3.57,6.2,6.2,0,0,0-4.74-1.72,6,6,0,0,0-4,1.44,7.28,7.28,0,0,0-2.31,3.85Z",
    style: {
      fill: "#5f6368"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirebaseLogo);
export default __webpack_public_path__ + "static/media/firebaseLogo.77be4678efec8bf3e35a59a4ebc80c23.svg";
export { ForwardRef as ReactComponent };